import firebase from "firebase/app";
import { tReferral, tReferralStatus, validate } from "tmt_api/src/types/types.validator";

export type tQueryReferralsParams = {
  senderId?: string;
  receiverEmail?: string;
  status?: tReferralStatus | tReferralStatus[];
  type?: "brand" | "rep";
};

export const documentReferral = (id: string): firebase.firestore.DocumentReference<tReferral> =>
  firebase
    .firestore()
    .collection("referrals")
    .doc(id)
    .withConverter<tReferral>({
      toFirestore: (data) => data,
      fromFirestore: (snapshot) => validate("tReferral")(snapshot.data()),
    });

export const queryReferral = (params?: tQueryReferralsParams): firebase.firestore.Query<tReferral> => {
  let collectionRef: firebase.firestore.Query = firebase
    .firestore()
    .collection("referrals")
    .orderBy("createdAt", "desc");

  if (params?.senderId) collectionRef = collectionRef.where("senderId", "==", params.senderId);
  if (params?.receiverEmail) collectionRef = collectionRef.where("receiverEmail", "==", params.receiverEmail);
  if (params?.status)
    collectionRef = collectionRef.where("status", Array.isArray(params?.status) ? "in" : "==", params.status);
  if (params?.type) collectionRef = collectionRef.where("type", "==", params.type);

  return collectionRef.withConverter<tReferral>({
    toFirestore: (data) => data,
    fromFirestore: (snapshot) => validate("tReferral")(snapshot.data()),
  });
};
